import { studioViewIdentity } from "../workspace/studio-views";

type Edit = (
  sceneId: string,
  button: HTMLButtonElement,
) => Promise<void> | void;
let current: { projectId: string; edit: Edit } | undefined;

/** The existing controller owns editing. Keep one route-scoped bridge, even when the cards outlet is hidden. */
export function registerStoryboardEditor(projectId: string, edit: Edit) {
  current = { projectId, edit };
}
export async function openStoryboardEditor(
  projectId: string,
  sceneId: string,
  button: HTMLButtonElement,
) {
  if (
    !current ||
    current.projectId !== projectId ||
    studioViewIdentity("storyboard-cards") !== `storyboard-cards:${projectId}`
  ) {
    throw new Error(
      "Open this production's storyboard before editing the shot.",
    );
  }
  await current.edit(sceneId, button);
}
